import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface InvoiceData {
    doctorId: number;
    servicePointId: number;
    doctorSignature: string;
    patientSignature: string;
}

interface InvoiceState {
    invoices: (InvoiceData | null)[];
    newInvoice: InvoiceData | null;
    currentInvoice: InvoiceData | null;
    defaultInvoice: InvoiceData | null;
}

const initialState: InvoiceState = {
    invoices: [],
    newInvoice: null,
    currentInvoice: null,
    defaultInvoice: null,
};

export const invoiceSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {
        appendInvoice: (state, action: PayloadAction<{ index: number; value: InvoiceData }>) => {
            state.invoices[action.payload.index] = action.payload.value;
        },
        removeInvoice: (state, action: PayloadAction<{ index: number }>) => {
            state.invoices[action.payload.index] = null;
        },
        updateInvoice: (state, action: PayloadAction<{ index: number; data: Partial<InvoiceData> }>) => {
            if (state.invoices[action.payload.index]) {
                state.invoices[action.payload.index] = {
                    ...state.invoices[action.payload.index],
                    ...action.payload.data
                } as InvoiceData;
            }
        },
        setNewInvoice: (state, action: PayloadAction<InvoiceData | null>) => {
            state.newInvoice = action.payload;
        },
        setCurrentInvoice: (state, action: PayloadAction<InvoiceData | null>) => {
            state.currentInvoice = action.payload;
        },
        setDefaultInvoice: (state, action: PayloadAction<InvoiceData | null>) => {
            state.defaultInvoice = action.payload;
        },
        updateNewInvoice: (state, action: PayloadAction<Partial<InvoiceData>>) => {
            if (state.newInvoice) {
                state.newInvoice = { ...state.newInvoice, ...action.payload };
            }
        },
        updateCurrentInvoice: (state, action: PayloadAction<Partial<InvoiceData>>) => {
            if (state.currentInvoice) {
                state.currentInvoice = { ...state.currentInvoice, ...action.payload };
            }
        },
    }
});

export const {
    appendInvoice,
    removeInvoice,
    updateInvoice,
    setNewInvoice,
    setCurrentInvoice,
    setDefaultInvoice,
    updateNewInvoice,
    updateCurrentInvoice
} = invoiceSlice.actions;

export default invoiceSlice.reducer;

export const selectAllInvoices = (state: any) => state.invoice.invoices;
export const selectInvoiceByIndex = (state: any, index: number) => state.invoice.invoices[index];
export const selectNewInvoice = (state: any) => state.invoice.newInvoice;
export const selectCurrentInvoice = (state: any) => state.invoice.currentInvoice;
